import { skipToken, useQuery } from '@tanstack/react-query';

import { Skills } from '@air/api';
import { callAirApi } from '@air/utils-api';

export const PRIVATE_SKILL_KEY = 'PRIVATE_SKILL';

export type PrivateSkillKey = [typeof PRIVATE_SKILL_KEY, UsePrivateSkillParams];

export const getPrivateSkillKey = (params: UsePrivateSkillParams): PrivateSkillKey => [PRIVATE_SKILL_KEY, params];

export type UsePrivateSkillParams = Omit<NonNullable<Parameters<typeof Skills.get>[0]>, 'workspaceId' | 'skillId'> & {
  workspaceId: string | undefined;
  skillId: string | undefined;
};

export type UsePrivateSkillOptions = {
  enabled?: boolean;
};

export const usePrivateSkill = (params: UsePrivateSkillParams, options?: UsePrivateSkillOptions) => {
  const { workspaceId, skillId } = params;

  return useQuery({
    queryKey: getPrivateSkillKey(params),
    queryFn: workspaceId && skillId ? () => callAirApi(() => Skills.get({ workspaceId, skillId })) : skipToken,
    enabled: !!workspaceId && !!skillId && options?.enabled !== false,
  });
};
